import { InputAdornment, TextField, Typography } from "@material-ui/core";
import { MailOutline } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import { useState } from "react";
import { Link } from "react-router-dom";
import CustomButton from "../../components/buttons/CustomButton";
import FlexContainer from "../../components/containers/FlexContainer";
import Form from "../../components/form/Form";
import { useRequestPasswordReset } from "../../domains/session/services/sessionServices";
import { useLangLabels } from "../../shared/lang/services/useLangLabels";
import { USER_ROUTES } from "../../shared/routes/routes";
import LoginFormContainer from "./components/LoginFormContainer";

const PasswordRecoveryPage: React.FC<{}> = () => {
  const { lang } = useLangLabels();
  const { mutate, status } = useRequestPasswordReset();

  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = () => {
    mutate({ email }, { onSuccess: () => setSent(true) });
  };

  return (
    <LoginFormContainer size="md">
      <FlexContainer flexDirection="column" gap="16px" width="100%">
        <Typography variant="h6" align="center">
          {lang.passwordRecovery.title}
        </Typography>

        {sent ? (
          <Alert style={{ width: "100%", boxSizing: "border-box" }} severity="success">
            {lang.passwordRecovery.successMessage}
          </Alert>
        ) : (
          <Form onSubmit={handleSubmit}>
            <TextField
              color="secondary"
              variant="outlined"
              placeholder={lang.passwordRecovery.emailPlaceholder}
              required
              autoComplete="off"
              type="email"
              name="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <MailOutline color="secondary" />
                  </InputAdornment>
                ),
              }}
            />

            {status === "error" ? (
              <Alert style={{ width: "100%", boxSizing: "border-box" }} severity="error">
                {lang.messages.anErrorHasOccurred}
              </Alert>
            ) : null}

            <CustomButton
              styleProps={{ height: "40px" }}
              type="submit"
              color="secondary"
              status={status === "loading" ? "loading" : undefined}
            >
              {lang.passwordRecovery.sendButton}
            </CustomButton>
          </Form>
        )}

        <FlexContainer justify="center" width="100%">
          <Link to={`/${USER_ROUTES.login}`}>{lang.passwordRecovery.backToLogin}</Link>
        </FlexContainer>
      </FlexContainer>
    </LoginFormContainer>
  );
};

export default PasswordRecoveryPage;
